import { useEffect, useState } from "react";

// 🔹 Hook para detectar si la pantalla está en orientación landscape
const useIsLandscape = (): boolean => {
  // Verifica que estemos en un entorno cliente (navegador)
  const isClient = typeof window !== "undefined";

  // Estado que indica si estamos en landscape (ancho > alto)
  const [isLandscape, setIsLandscape] = useState(
    isClient ? window.innerWidth > window.innerHeight : false
  );

  useEffect(() => {
    if (!isClient) return; // ❌ No hacer nada si estamos en SSR

    // Función que actualiza el estado según la orientación actual
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    // Escuchar cambios de tamaño de ventana
    window.addEventListener("resize", handleResize);

    // Ejecuta al montar para asegurar que el estado esté correcto
    handleResize();

    // Limpieza: remover listener al desmontar
    return () => window.removeEventListener("resize", handleResize);
  }, [isClient]);

  return isLandscape; // Devuelve true si landscape, false si portrait
};

export default useIsLandscape;
